/**
 * Generic Slider functionality
 */

import { Swiper } from 'swiper';
import { Navigation, Mousewheel } from 'swiper/modules';

export function initGenericSliders() {
    const sliders = document.querySelectorAll('.generic-slider__container .swiper');
    
    sliders.forEach(slider => {
        const sliderId = slider.getAttribute('id');
        if (!sliderId) return;
        
        const sliderContainer = slider.closest('.acc_equipe, .acc_clients, .success-stories-slider') || slider.closest('section');
        const prevButton = sliderContainer?.querySelector('.generic-slider__nav--prev');
        const nextButton = sliderContainer?.querySelector('.generic-slider__nav--next');
        
        let offsetBefore = 150; 
        let offsetAfter = 0; 
        
        if (sliderId === 'success-stories-slider') {
            offsetBefore = 0;
            offsetAfter = 0;
        }
        
        const swiperInstance = new Swiper(slider, {
            modules: [Navigation, Mousewheel],
            slidesPerView: 'auto',
            spaceBetween: 20,
            slidesOffsetBefore: offsetBefore,
            centeredSlides: false,
            loop: false,
            loopAdditionalSlides: 0,
            initialSlide: 0,
            watchSlidesProgress: true,
            watchSlidesVisibility: true,
            slidesPerGroup: 1,
            watchOverflow: false,
            touchEventsTarget: 'container',
            simulateTouch: true,
            allowTouchMove: true,
            touchMoveStopPropagation: false,
            grabCursor: true,
            mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
                releaseOnEdges: true,
            },
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
            breakpoints: {
                320: {
                    slidesPerView: 'auto',
                    spaceBetween: 15,
                    slidesOffsetBefore: sliderId === 'success-stories-slider' ? 0 : 20,
                    slidesOffsetAfter: sliderId === 'success-stories-slider' ? 0 : 20,
                },
                768: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    slidesOffsetBefore: sliderId === 'success-stories-slider' ? 0 : 50,
                    slidesOffsetAfter: sliderId === 'success-stories-slider' ? 0 : 50,
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    slidesOffsetBefore: offsetBefore,
                    slidesOffsetAfter: offsetAfter, 
                },
                1200: {
                    slidesPerView: 'auto',
                    spaceBetween: 20,
                    slidesOffsetBefore: offsetBefore,
                    slidesOffsetAfter: sliderId === 'success-stories-slider' ? 0 : 150, 
                }
            },
            on: {
                init: function() {
                    console.log(`Generic slider initialized: ${sliderId}`);
                    this.updateSlidesProgress();
                },
                slideChange: function() {
                    console.log(`Current slide: ${this.activeIndex} (${sliderId})`);
                    console.log(`Is beginning: ${this.isBeginning}`);
                    console.log(`Is end: ${this.isEnd}`);
                }
            }
        });
    });
}
